module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "standings.8618db5e.webp";